<template>
    <el-card class="koku-list">
        <template slot="header">
            <el-row type="flex" justify="space-between">
                <h4>Koku Listesi</h4>
                <el-button icon="el-icon-plus" @click="add">Koku Ekle</el-button>
            </el-row>
        </template>

        <el-table v-loading="loading" :data="list" empty-text="Henuz Koku eklenmedi!">
            <el-table-column prop="adi" label="Koku Adi"></el-table-column>
            <el-table-column prop="esans" label="Koku Esans"></el-table-column>
            <el-table-column prop="hacim" label="Büyüklük"></el-table-column>
            <el-table-column>
                <template slot-scope="{ row }">
                    <el-button icon="el-icon-edit" title="Güncelle" size="small" @click="update(row)"></el-button>
                    <el-popconfirm
                        title="Silmek istediginize emin misiniz?"
                        confirmButtonText="Evet"
                        cancelButtonText="iptal"
                        @onConfirm="remove(row)"
                    >
                        <el-button
                            slot="reference"
                            icon="el-icon-delete"
                            title="Sil"
                            size="small"
                            type="danger"></el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog
            :title="`Koku ${ koku ? 'Güncelle' : 'Ekle'}`"
            :visible.sync="visible"
            width="100%">

            <koku-form v-if="visible" :koku="koku" :visible="visible" @success="success"/>

        </el-dialog>
    </el-card>
</template>

<script>
import KokuForm from './KokuForm.vue'

export default {
    name: 'koku-list',
    components: {KokuForm},
    data() {
        return {
            visible: false,
            loading: false,
            list: [],
            koku: null,
        };
    },
    methods: {
        add() {
            this.koku = null;
            this.visible = true;
        },
        update(koku) {
            this.koku = Object.assign({}, koku);
            this.visible = true;
        },
        remove(koku) {
            this.loading = true;
            this.$requests.Koku.deleteKoku(koku.id)
                .then(() => {
                    console.debug('removed successfully', koku.id);
                    this.fetch();
                })
                .catch((e) => {
                    console.error('error', e);
                })
                .then(() => {
                    this.loading = false;
                })
        },
        success() {
            this.visible = false;
            this.fetch();
        },
        fetch() {
            this.loading = true;
            this.$requests.Koku.getKoku()
                .then((data) => {
                    this.list = data
                        .map((d) => {
                            d.olcum_harcanan = d.olcum_harcanan ? parseInt(d.olcum_harcanan) : null;
                            d.olcum_yogunluk = d.olcum_yogunluk ? parseInt(d.olcum_yogunluk) : null;
                            d.olcum_sure = d.olcum_sure ? parseInt(d.olcum_sure) : null;
                            return d;
                        });
                })
                .catch((e) => {
                    console.error('error', e);
                })
                .then(() => {
                    this.loading = false;
                });
        },
    },
    mounted() {
        this.fetch();
    },
}
</script>
